module.exports = __webpack_public_path__ + "img/home_picture_default@2x.2dab4397.png";